import { useEffect, useState } from "react";
import { rafThrottle } from "../utils/rafThrottle";

/** 0–1 ratio of vertical scroll through the document. */
export function useDocumentScrollProgress() {
  const [ratio, setRatio] = useState(0);

  useEffect(() => {
    const update = () => {
      const el = document.documentElement;
      const maxScroll = el.scrollHeight - el.clientHeight;
      setRatio(maxScroll > 0 ? Math.min(1, window.scrollY / maxScroll) : 0);
    };

    const onScrollOrResize = rafThrottle(update);
    update();
    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);
    return () => {
      window.removeEventListener("scroll", onScrollOrResize);
      window.removeEventListener("resize", onScrollOrResize);
    };
  }, []);

  return ratio;
}
